
export const search = {
  'search.filters.title': 'Search & Filter Options',
  'search.filters.geographicEligibility': 'Location & Eligibility',
  'search.filters.region': 'Your Region',
  'search.filters.eligibleCountry': 'Country/Territory',
  'search.filters.agriculturalSector': 'Farm Type & Crops',
  'search.filters.farmingType': 'What You Grow/Raise',
  'search.filters.farmingType.arableCrops': 'Field Crops (wheat, corn, etc.)',
  'search.filters.farmingType.vineyards': 'Vineyards & Wine',
  'search.filters.farmingType.livestock': 'Livestock & Dairy',
  'search.filters.farmingType.aquaculture': 'Fish & Aquaculture',
  'search.filters.farmingType.mixedFarming': 'Mixed Farming',
  'search.filters.farmingType.greenhouse': 'Greenhouse & Vertical Farming',
  'search.filters.fundingType': 'Funding Options',
  'search.filters.fundingSource': 'Funding Source',
  'search.filters.fundingSource.public': 'Government & EU Funding',
  'search.filters.fundingSource.private': 'Bank & Private Loans',
  'search.filters.fundingSource.hybrid': 'Mixed Public-Private',
  'search.filters.fundingInstrument': 'Type of Support',
  'search.filters.fundingInstrument.grant': 'Grants & Direct Payments',
  'search.filters.fundingInstrument.subsidy': 'Subsidies & Support',
  'search.filters.fundingInstrument.taxCredit': 'Tax Credits & Breaks',
  'search.filters.fundingInstrument.loan': 'Loans & Financing',
  'search.filters.fundingInstrument.technicalAssistance': 'Training & Support',
  'search.filters.applicationRequirements': 'Application Requirements',
  'search.filters.documentsRequired': 'Documents You Need',
  'search.filters.documentsRequired.businessPlan': 'Business/Farm Plan',
  'search.filters.documentsRequired.sustainabilityReport': 'Environmental Report',
  'search.filters.documentsRequired.carbonAssessment': 'Carbon Assessment',
  'search.filters.documentsRequired.euFarmId': 'EU Farm Registration',
  'search.filters.documentsRequired.digitalCertification': 'Digital Certificates',
  'search.filters.documentsRequired.previousGrantRecord': 'Previous Funding History',
  'search.filters.applicationFormat': 'How to Apply',
  'search.filters.applicationFormat.online': 'Online Application',
  'search.filters.applicationFormat.pdf': 'PDF Forms',
  'search.filters.applicationFormat.portal': 'Government Portal',
  'search.filters.applicationFormat.consultant': 'Through Consultant Only',
  'search.filters.strategicAlignment': 'Farm Goals & Sustainability',
  'search.filters.sustainabilityGoals': 'Environmental Goals',
  'search.filters.sustainabilityGoals.organicTransition': 'Go Organic',
  'search.filters.sustainabilityGoals.waterEfficiency': 'Water Conservation',
  'search.filters.sustainabilityGoals.emissionReduction': 'Reduce Carbon Footprint',
  'search.filters.sustainabilityGoals.soilHealth': 'Improve Soil Health',
  'search.filters.sustainabilityGoals.biodiversity': 'Protect Wildlife & Biodiversity',
  'search.filters.sustainabilityGoals.climateAdaptation': 'Climate-Resilient Farming',
  'search.filters.deadlineStatus': 'Application Timeline',
  'search.filters.deadline': 'Application Deadline',
  'search.filters.deadline.open': 'Applications Open',
  'search.filters.deadline.closingSoon': 'Closing Soon (30 days)',
  'search.filters.deadline.closed': 'Closed (for reference)',
  'search.noResults': 'No funding opportunities found matching your criteria',
  'search.noResultsDesc': 'Try broadening your search or removing some filters to see more opportunities.',
  'search.filters.noMatches': 'No saved filter sets yet',
  'search.filters.saveFilterSet': 'Save These Filters',
  'search.filters.savedFilters': 'Your Saved Searches',
  'search.filters.enterFilterSetName': 'Name this filter set',
  'search.filters.save': 'Save Filters',
  'search.filters.cancel': 'Cancel',
  'search.filters.apply': 'Apply Filters',
  'search.actions.attached': 'Saved to Farm',
  'search.actions.attach': 'Save to My Farm',

  // Missing keys for SubsidySearchPage
  'search.fundingSearch': 'Find Funding Opportunities',
  'search.opportunitiesAvailable': 'opportunities available',
  'search.errorLoadingOpportunities': 'Error loading opportunities',
  'search.errorLoadingDescription': 'Please try again later',
  'search.quickFilters': 'Quick Filters',
  'search.smartFilters': 'Smart Filters',
  'retry': 'Try Again',

  // Quick filter buttons
  'search.quickFilters.subsidies': 'Subsidies',
  'search.quickFilters.regions': 'Main Regions',
  'search.quickFilters.agriculture': 'Agriculture',
  'search.quickFilters.urgent': 'Urgent',

  // UI descriptions
  'search.idealMatch': 'Find your ideal funding match',
  'search.popularCombos': 'Popular Combinations:',
  'search.smartFiltersTitle': 'Smart Filters & Search',
  'search.smartFiltersDescription': 'Smart Filters',

  // French Subsidy Search placeholders
  'search.placeholders.searchByTitleDescriptionAgency': 'Search by title, description or agency...',
  'search.placeholders.fundingType': 'Funding Type',
  'search.placeholders.sector': 'Sector',
  'search.placeholders.region': 'Region',
  'search.placeholders.minAmount': 'Min Amount (€)',
  'search.placeholders.maxAmount': 'Max Amount (€)',
  'search.placeholders.allTypes': 'All types',
  'search.placeholders.allSectors': 'All sectors',
  'search.placeholders.allRegions': 'All regions',

  // Smart Filter Panel placeholders
  'search.placeholders.describeProjectOrKeywords': 'Describe your project or search by keywords...',
  'search.placeholders.selectRegion': 'Select region',
  'search.placeholders.selectCategory': 'Select category',
  'search.placeholders.selectCountry': 'Select country first',
  'search.placeholders.selectDepartment': 'Select department',

  // Conversational placeholders
  'search.placeholders.describeProjectOrFunding': 'Describe your project or funding need... (Shift+Enter for new line)',

  // Filter panel titles (NEW SIMPLIFIED STRUCTURE)
  'search.searchAndFilterOptions': 'Find Financial Support',
  'search.fundingOrganizations': 'Funding Organizations',
  'search.majorFunders': 'Major Funders',
  'search.otherOrganizations': 'Other Organizations',
  'search.filters.moreOrganizations': '+{count} more organizations',
  'search.filters.moreRegions': '+{count} more regions',
  'search.filters.showLess': 'Show less',
  'search.filters.showMore': '+{count} filters',
  'search.filters.loadingOrganizations': 'Loading organizations...',
  'search.filters.active': 'active',
  'search.filters.clearAll': 'Clear all',

  // New filter sections (SIMPLIFIED STRUCTURE)
  'search.bySituation': 'By Your Situation',
  'search.byFundingType': 'By Funding Type',
  'search.byProjectTheme': 'By Project Theme',
  'search.byDeadline': 'By Deadline & Eligibility',
  'search.companySize': 'Company Size',
  'search.companySize.tpe': 'Micro (0-9 employees)',
  'search.companySize.pme': 'SME (10-249 employees)',
  'search.companySize.eti': 'Mid-cap (250-4999 employees)',
  'search.companySize.ge': 'Large (5000+ employees)',
  'search.amountLabel': 'Amount',
  'search.projectState': 'Application Status',
  'search.projectState.open': 'Currently Open',
  'search.projectState.closingSoon': 'Closing Soon (less than 30 days)',
  'search.projectState.openingSoon': 'Opening Soon',
  'search.projectState.closed': 'Closed (for reference)',
  'search.specialCriteria': 'Special Criteria',
  'search.specialCriteria.online': '100% Online Process',
  'search.specialCriteria.newCompany': 'For New Businesses',

  // Project themes (NEW)
  'search.themes.ecological': 'Ecological Transition',
  'search.themes.renewableEnergy': 'Renewable Energy',
  'search.themes.circularEconomy': 'Circular Economy',
  'search.themes.energyRenovation': 'Energy Renovation',
  'search.themes.wasteReduction': 'Waste Reduction',
  'search.themes.innovation': 'Innovation & Digital',
  'search.themes.rd': 'R&D',
  'search.themes.digitalization': 'Digitalization',
  'search.themes.cybersecurity': 'Cybersecurity',
  'search.themes.international': 'International',
  'search.themes.export': 'Export',
  'search.themes.foreignExpansion': 'Foreign Expansion',
} as const;
